<template>
  <div>
        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
            <div style="width: 40%; text-align: left;">
                <el-input 
                    @focus="$event.target.select()"
                    placeholder="Search..."
                    size="small"
                    clearable
                    @clear="clearSearch"
                    style="width: 350px; text-align: left;"
                    v-model="search_term_1"
                    @keyup.enter.native="search_term = search_term_1">
                </el-input>

            </div>
            
            <div style="width: 40%; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                
                <el-button v-if="!calendar_view && $store.state.production.planner.search_type <2" size="small" @click="updateAllPromises" :loading="processing" style="margin-right: 10px;">
                    Update All Promises
                </el-button>
                
                <el-dropdown 
                    @command="handleDropdownCommand">
                    <el-button size="small" type="primary" style="margin-right: 5px;">
                        Download CSV<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" align="left">
                        <el-dropdown-item command="downloadOverview">Overview List</el-dropdown-item>
                        <el-dropdown-item command="downloadList">Item List</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>
        <br>
        <el-table
            :summary-method="getSummaries"
            :show-summary="true"
            :data="getFinalList.slice(($store.getters.getDefaultPageLimit*page_number)-$store.getters.getDefaultPageLimit, 
                ($store.getters.getDefaultPageLimit*page_number))"
            style="width: 100%"
            :default-sort = "{prop: 'date', order: 'ascending'}">
          <el-table-column 
            sortable
            prop="customer_code"
            label="Cust#" width="100">
            <template slot-scope="scope">
                <span class="rowFontSize">
                    <el-link v-if="!calendar_view" @click="$emit('loadCustomerInvoiceList', 
                    {
                        customer_id: scope.row.customer_id, 
                        label: scope.row.customer_name
                    })" style="text-decoration: underline;">
                    {{scope.row.customer_code}}
                </el-link>
                <span v-else class="rowFontSize">
                    {{scope.row.customer_code}}
                </span>
                </span>                
            </template>
          </el-table-column>
          <el-table-column 
            sortable
            prop="customer_name"
            label="Customer" width="200">
            <template slot-scope="scope">
                <span class="rowFontSize">
                    <el-link v-if="!calendar_view" @click="$emit('loadCustomerInvoiceList', 
                    {
                        customer_id: scope.row.customer_id, 
                        label: scope.row.customer_name
                    })" style="text-decoration: underline;">
                    {{scope.row.customer_name}}
                </el-link>
                <span v-else class="rowFontSize">
                    {{scope.row.customer_name}}
                </span>
                </span>                
            </template>
          </el-table-column>

            <el-table-column             
            sortable
            prop="dd_activity"            
            label="Activity" width="150">
            <template slot-scope="scope">
                <el-select 
                    size="small"
                    v-model="scope.row.dd_activity" 
                    filterable 
                    :allow-create="$store.getters.getAccessRights.can_add"
                    style="width: 125px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.state.customerMaster.customer_dd.dd_activity"
                        :key="index"
                        :label="data"
                        :value="data">
                        <span style="float: left" v-html="data"></span>
                    </el-option>
                </el-select>
            </template>
          </el-table-column>

          <el-table-column             
            sortable
            prop="dd_status"            
            label="Status" width="150">
            <template slot-scope="scope">                
                <el-select 
                    size="small"
                    v-model="scope.row.dd_status" 
                    filterable 
                    :allow-create="$store.getters.getAccessRights.can_add"
                    style="width: 125px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.state.customerMaster.customer_dd.dd_status"
                        :key="index"
                        :label="data"
                        :value="data">
                        <span style="float: left" v-html="data"></span>
                    </el-option>
                </el-select>              
            </template>
          </el-table-column>

          <el-table-column 
            sortable
            v-if="$store.state.production.planner.search_type <2"
            prop="appointment_date"
            label="Promise Date" width="165">
            <template slot-scope="scope">
                <el-date-picker
                    size="small"
                    type="date"
                    @change="addToPromiseDateArray(scope.row)"
                    v-model="scope.row.appointment_date"
                    style="width: 140px;" 
                    value-format="yyyy-MM-dd"
                    format="MMM dd yyyy">
                </el-date-picker>
            </template>
          </el-table-column>
          
        <el-table-column             
            sortable
            prop="dd_sales_coordinator"            
            label="Coordinator" width="150">
            <template slot-scope="scope">
                <el-select 
                    size="small"
                    v-model="scope.row.dd_sales_coordinator" 
                    style="width: 125px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getEmployeeMasterList"
                        :key="index"
                        :label="data.staff_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.staff_name"></span>
                    </el-option>
                </el-select>                                 
            </template>
          </el-table-column>

        <el-table-column 
            sortable
            prop="dd_notes"            
            label="Notes" width="250">
            <template slot-scope="scope">
                <el-input 
                    @focus="$event.target.select()"
                    size="small"
                    style="width: 225px; text-align: left;"
                    v-model="scope.row.dd_notes">
                </el-input> 
            <!--
            <el-select 
                size="small"
                v-model="scope.row.dd_notes" 
                filterable 
                :allow-create="true"
                style="width: 225px; text-align: left;">
                <el-option
                    v-for="(data, index) in $store.state.customerMaster.customer_dd.dd_notes"
                    :key="index"
                    :label="data"
                    :value="data">
                    <span style="float: left" v-html="data"></span>
                </el-option>
            </el-select>
            -->  
            </template>
          </el-table-column>

          <el-table-column 
            label="Counters" :width="(100+($store.getters.getItemCategoryList.length*100))">

            <el-table-column 
            sortable
            prop="total_orders"
            label="Total" align="center">
            <template slot-scope="scope">
                <span>
                    <b>{{scope.row.total_orders}}</b>
                    <span 
                        v-if="scope.row.delivery_ready.length>0"
                        style="color: green;">
                        ({{scope.row.delivery_ready.length}})
                    </span>
                    <span 
                        v-else-if="scope.row.trial_ready.length>0"
                        style="color: green;">
                        ({{scope.row.trial_ready.length}})
                    </span>
                </span>                
            </template>
          </el-table-column>

          <el-table-column 
            sortable
            v-for="(data, index) in $store.getters.getItemCategoryList"
            :key="index"
            :label="data.category_name" align="center">
                <template slot-scope="scope">
                    
                    <span v-if="scope.row[data.category_name] !== undefined">
                        <b>{{scope.row[data.category_name].data_list.length}}</b>
                        <span 
                            v-if="scope.row[data.category_name].data_list.filter(t => t.hidden_process > 0 && t.work_status===0).length"
                            style="color: green;">
                            ({{scope.row[data.category_name].data_list.filter(t => t.hidden_process > 0 && t.work_status===0).length}})
                        </span>
                        
                    </span>
                    <span v-else>
                        -
                    </span>
                    
                </template>                
          </el-table-column>
          </el-table-column>  

          

          <el-table-column
                fixed="right"
                label=""
                width="70">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        
                        <a 
                            v-if="!calendar_view"
                            title="Add Task"
                            @click="$emit('addTask', {title: scope.row.customer_name+' Orders', description: 'Pending Orders'})" 
                            style="cursor: pointer;">
                            <i :class="'el-icon-date'"></i>
                        </a>

                        <el-tooltip class="item" effect="dark" content="View" style="margin-left: 10px;">
                          <a 
                            title="Work Status"
                            @click="openOrderDetails(scope.row)" 
                            style="cursor: pointer;">
                            <i :class="$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                          </a>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>

        </el-table>
        <br>
        <div style="text-align: right;">
            <el-pagination
                background
                @size-change="handleSizeChange"
                :current-page.sync="page_number"
                :page-size.sync="$store.getters.getDefaultPageLimit"
                layout="total, sizes, prev, pager, next"
                :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
                :total="getFinalList.length">
            </el-pagination>
        </div>
        <el-dialog
            :title="getSelectedCustomerName"
            v-if="show_detail_list"
            fullscreen
            :visible.sync="show_detail_list"
            append-to-body>
                <DetailList
                    @addTask="addTask"
                    :plannerSource="true"
                    :searchType="searchType"
                    :customer_id="getSelectedCustomerId"
                    @closed="show_detail_list = false"/>
        </el-dialog>

  </div>
</template>

<script>
import DetailList from '../../ReadyOrders/DetailList.vue'

export default {
    components: {DetailList},
    props: ['data_list', 'searchType', 'calendar_view'],
    data() {
      return {
        selected_list: [],
        selected_customer_name: '',
        show_detail_list: false,
        search_term: '',
        search_term_1: '',
        dd_priority_date: '',
        promise_date_array: [],
        processing: false,
        page_number: 1,
        
      }
    },
    computed: {
        getCSVItemList() {
            
            let dataList = [];
            this.data_list.forEach(element => {
                dataList.push(element)
            })

            let data = []

            let returnData = {
                wo_number: 'WO#',
                promise_date: 'Promise Date',
                customer: 'Customer',
                category: 'Category Name',
                sub_category: 'Sub-Category',
                garment_name: 'Garment',
                process_name: 'Current Process',
                status: 'work_order_status'
            }

            data.push(returnData)
            
            const allItemCategoryList = this.$store.getters.getAllItemCategoryList
            
            dataList.forEach(element => {

                const subCategoryIndex = allItemCategoryList.findIndex(t => t.id === element.sub_category_id)

                let returnData = {
                    wo_number: element.work_order_number,
                    promise_date: element.appointment_date_changed,
                    customer: element.customer_name,
                    category: element.category_name,
                    sub_category: subCategoryIndex>=0 ? allItemCategoryList[subCategoryIndex].sub_category_name : '',
                    garment_name: element.template_name,
                    process_name: element.process_name,
                    status: element.work_order_status
                }

                data.push(returnData)

            })
            return data
            
        },
      getCSVList() {
            
            let data = []

            let returnData = {
                customer_id: 'Cust#',
                customer: 'Name',
                promise_date: 'Promise Date',
                promise_type: 'Type',
                total_orders: 'Total Orders',
                trial_ready: 'Trial Ready',
                delivery_ready: 'Delivery Ready',
            }

            this.$store.getters.getItemCategoryList.forEach(category => {

                let categoryFilter = this.data_list.filter(t => (t.category_id === category.id || t.sub_template_category_id === category.id))
                let node = category.category_name
                let obj = returnData                        
                if(categoryFilter.length>0) {
                    obj[node] = category.category_name                    
                } else {
                    obj[node] = 0
                }

                node = category.category_name+' Ready'
                obj = returnData                        
                if(categoryFilter.length>0) {
                    obj[node] = category.category_name +' Ready'                   
                } else {
                    obj[node] = 0
                }

            })

            data.push(returnData)
            
            this.getDistinctCustomers.forEach(element => {

                let returnData = {
                    customer_id: element.customer_code,
                    customer: element.customer_name,
                    promise_date: this.changeDate(element.appointment_date),//element.sale_appointment_date_changed,
                    promise_type: element.appointment_type === 0 ? 'Delivery' : 'Trial',
                    total_orders: this.data_list.filter(t => t.customer_id === element.customer_id).length,
                    trial_ready: this.data_list.filter(t => t.customer_id === element.customer_id && t.hidden_process == 1).length,
                    delivery_ready: this.data_list.filter(t => t.customer_id === element.customer_id && t.hidden_process == 2).length
                }

                this.$store.getters.getItemCategoryList.forEach(category => {

                    let categoryFilter = this.data_list.filter(t => (t.category_id === category.id || t.sub_template_category_id === category.id) && t.customer_id === element.customer_id)
                    let node = category.category_name
                    let obj = returnData                        
                    if(categoryFilter.length>0) {
                        obj[node] = categoryFilter.length
                    } else {
                        obj[node] = 0
                    }

                    node = category.category_name+' Ready'
                    obj = returnData                        
                    if(categoryFilter.length>0) {
                        obj[node] = this.data_list.filter(t => (t.category_id === category.id || t.sub_template_category_id === category.id) && t.customer_id === element.customer_id && t.hidden_process > 0).length
                    } else {
                        obj[node] = 0
                    }

                })

                data.push(returnData)

            })
            return data

            
      },
      getResultKeys() {
          let payload = [
            {value: "t2.appointment_date", label: "Promise Date", date_field: true}, 
            {value: "t2.appointment_date_array", label: "Promise Date Range", date_range_field: true}, 
            {value: "t6.customer_name", label: "Customer Name"}, 
            {value: "t6.company_name", label: "Company Name"}]
            
          return payload
      },
      getSelectedCustomerName() {
          return this.selected_customer_name
      },
      getSelectedCustomerId() {
          return this.selected_customer_id
      },
      getSelectedList() {
        return this.selected_list
      },
      getDistinctCustomers() {
            
          let returnList = this.data_list
          
          let filterList = returnList
          if(this.search_term.length>0) {
            filterList = returnList.filter(t => t.customer_name.toLowerCase().match(this.search_term.toLowerCase()))  
          }
          
          let list = filterList.filter((thing, index, self) =>
                index === self.findIndex((t) => (t.customer_id === thing.customer_id))
          )
          
          return list
      },
      getFinalList() {
            let returnList = []

            this.getDistinctCustomers.forEach(element => {
                
                let dd_activity = element.dd_activity
                let dd_status = element.dd_status
                let dd_promise_date = element.dd_promise_date
                let dd_notes = element.dd_notes
                let dd_sales_coordinator = element.dd_sales_coordinator
                let dd_priority_date = element.dd_priority_date
                
                if(dd_activity === null || dd_activity.length === 0) {
                    dd_activity = element.appointment_type === 0 ? 'Delivery' : 'Trial'
                }
                if(dd_promise_date === null || dd_promise_date.length === 0) {
                    dd_promise_date = element.appointment_date
                }
                if(dd_priority_date === null || dd_priority_date.length === 0) {
                    dd_priority_date = dd_promise_date
                }
                if(dd_sales_coordinator === null || dd_sales_coordinator === 0) {
                    dd_sales_coordinator = element.sale_person_staff_id
                }
                
                let newElement = {
                    customer_id: element.customer_id,
                    customer_code: element.customer_code,
                    store_id: element.store_id,
                    customer_name: element.customer_name,
                    promise_type: element.appointment_type,
                    appointment_date: element.appointment_date,
                    appointment_date_changed: element.sale_appointment_date !== null ? element.sale_appointment_date_changed : element.appointment_date_changed,
                    total_orders: this.data_list.filter(t => t.customer_id === element.customer_id).length,
                    trial_ready: this.data_list.filter(t => t.customer_id === element.customer_id && t.hidden_process == 1),
                    delivery_ready: this.data_list.filter(t => t.customer_id === element.customer_id && t.hidden_process == 2),
                    dd_activity,
                    dd_status,
                    dd_promise_date,
                    dd_priority_date,
                    dd_notes,
                    dd_sales_coordinator,
                    work_order_list: this.data_list.filter(t => t.customer_id === element.customer_id)
                }

                this.$store.getters.getItemCategoryList.forEach(category => {

                    let categoryFilter = this.data_list.filter(t => (t.category_id === category.id || t.sub_template_category_id === category.id) && t.customer_id === element.customer_id)
                    if(categoryFilter.length>0) {
                        
                        let node = category.category_name
                        let obj = newElement
                        obj[node] = {
                            data_list: categoryFilter
                        }
                        
                    }
                })
                
                returnList.push(newElement)
            })

            return returnList
      }
    },
    methods: {
       addTask($event) {
            this.$emit('addTask', $event)
        },
        handleDropdownCommand(command) {
            if(command == 'downloadOverview') {
                this.$store.dispatch('downloadCSV', {data: this.getCSVList, title: 'All_Customer_Promises'})
            } else if(command == 'downloadList') {
                this.$store.dispatch('downloadCSV', {data: this.getCSVItemList, title: 'All_Item_Promises'})
            }
        },
        async handleSizeChange($val) {
            this.$store.state.master.default_page_limit = parseInt($val)
            await this.$store.dispatch('updatePageLimit', {limit: this.$store.state.master.default_page_limit})            
        },
        updateAllPromises() {
            this.processing = true
            this.promise_date_array.forEach(element => {
                this.submitCustomerDD(element)
            })

            setTimeout(() => {
                this.processing = false
                this.promise_date_array = []
            }, 2000);
        },
        addToPromiseDateArray(rowData) {
            /*rowData.work_order_list.forEach(workOrder => {
                this.promise_date_array.push(workOrder.work_order_id)
            })*/
            if(this.promise_date_array.findIndex(t => t.customer_id === rowData.customer_id)<0) {
                this.promise_date_array.push(rowData)
            }
            
            setTimeout(() => {
                rowData.work_order_list.forEach(workOrder => {

                    let filterIndex = this.$store.state.production.planner.list.future_orders.findIndex(t => t.work_order_id == workOrder.work_order_id)
                    
                    if(filterIndex>=0) {

                        let dateValue = new Date(rowData.appointment_date)
                        let monthValue = dateValue.getUTCMonth()

                        let monthName = this.masterMonthShort[monthValue]
                        
                        let monthDisplay = monthName+" "+dateValue.getUTCFullYear()

                        this.$store.state.production.planner.list.future_orders[filterIndex].work_order_month = monthDisplay
                        this.$store.state.production.planner.list.future_orders[filterIndex].appointment_date = rowData.appointment_date
                        this.$store.state.production.planner.list.future_orders[filterIndex].appointment_date_changed = this.changeDate(rowData.appointment_date)

                        if(dateValue<new Date()) {
                            this.$store.state.production.planner.list.future_orders[filterIndex].failed = true
                        } else {
                            this.$store.state.production.planner.list.future_orders[filterIndex].failed = false
                        }

                    }
                })
    
            }, 1000);
            
        },
        submitCustomerDD(rowData) {

            let work_orders = []

            rowData.work_order_list.forEach(workOrder => {
                work_orders.push(workOrder.work_order_id)
            })

            rowData.work_orders = work_orders
            this.$store.dispatch('submitCustomerDD', rowData)

        },
        loadList($event) {
            this.$store.state.production.nav.search_term = $event.search_term
            this.$store.state.production.nav.total = 0
            this.$store.state.production.nav.page_number = 1
            this.$store.state.production.nav.search_term_array = $event.search_term_array
            this.navigateButton()
        },
        clearSearch() {
            this.search_term = ''
            this.navigateButton()
        },
        navigateButton() {
          this.$emit('navigateMasterProductionQuery')
        },
        openOrderDetails(rowData) {
          this.selected_customer_id = rowData.customer_id
          this.selected_customer_name = rowData.customer_name
          
          let work_orders = []
          rowData.work_order_list.forEach(workOrder => {
                work_orders.push(workOrder.work_order_id)
          })

          this.$store.dispatch('openCustomerOrderDetails_ProductionStageWise', {customer_id: rowData.customer_id, work_orders})
          this.show_detail_list = true
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = 'Total';
                    return;
                } else if (index === 1) {
                    sums[index] = '';
                    return;
                } else if (index === 7) {
                    let total = 0;
                    let readyTotal = 0
                    this.getFinalList.forEach(element => {
                        total = total + element.total_orders
                        if((element.trial_ready.length)>0) {
                            readyTotal = readyTotal + (element.trial_ready.length)
                        } else {
                            readyTotal = readyTotal + (element.delivery_ready.length)
                        }
                        
                    })
                    sums[index] = total+' ('+readyTotal+')'
                    return;
                } else {
                    let key = 8
                    let total = 0;
                    let readyTotal = 0;
                    this.$store.getters.getItemCategoryList.forEach(element => {
                        total = 0
                        readyTotal = 0
                        this.getFinalList.forEach(element1 => {
                            if(element1[element.category_name] !== undefined) {
                                total = total + element1[element.category_name].data_list.length  
                                readyTotal = readyTotal +  element1[element.category_name].data_list.filter(t => t.hidden_process > 0 && t.work_status===0).length                             
                            }
                        })
                        if(readyTotal>0) {
                            sums[key] = total+' ('+readyTotal+')'
                        } else {
                            sums[key] = total
                        }
                        
                        key ++
                    })
                    
                    //sums[key] = total
                    return
                }
            })
            return sums;
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Planner/CustomerList/Summary.vue